// import { messageStatusOption } from '@/utils/constant/const.js'

export const searchFormConfig = {
  formItems: [
    {
      field: 'receiver',
      type: 'autocomplete',
      tableList: [],
      label: 'profile.receiver'
    },
    {
      field: 'title',
      type: 'input',
      label: 'profile.title'
    },
    // {
    //   field: 'status',
    //   type: 'select',
    //   options: messageStatusOption,
    //   label: 'common.app-status',
    //   otherOptions: {}
    // },
    {
      field: 'createTime',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
  ]
}
